/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdminRatioResponse } from './';
import {
    AdminRatioResponseFromJSON,
    AdminRatioResponseFromJSONTyped,
    AdminRatioResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdminConversationRateResponse
 */
export interface AdminConversationRateResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminConversationRateResponse
     */
    profileId: string;
    /**
     * 
     * @type {AdminRatioResponse}
     * @memberof AdminConversationRateResponse
     */
    month1?: AdminRatioResponse;
    /**
     * 
     * @type {AdminRatioResponse}
     * @memberof AdminConversationRateResponse
     */
    month3?: AdminRatioResponse;
    /**
     * 
     * @type {AdminRatioResponse}
     * @memberof AdminConversationRateResponse
     */
    month12?: AdminRatioResponse;
    /**
     * 
     * @type {AdminRatioResponse}
     * @memberof AdminConversationRateResponse
     */
    all?: AdminRatioResponse;
    /**
     * 
     * @type {Date}
     * @memberof AdminConversationRateResponse
     */
    lastComputation?: Date;
}

/**
 * Check if a given object implements the AdminConversationRateResponse interface.
 */
export function instanceOfAdminConversationRateResponse(value: object): value is AdminConversationRateResponse {
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    return true;
}

export function AdminConversationRateResponseFromJSON(json: any): AdminConversationRateResponse {
    return AdminConversationRateResponseFromJSONTyped(json, false);
}

export function AdminConversationRateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminConversationRateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'],
        'month1': json['month1'] == null ? undefined : AdminRatioResponseFromJSON(json['month1']),
        'month3': json['month3'] == null ? undefined : AdminRatioResponseFromJSON(json['month3']),
        'month12': json['month12'] == null ? undefined : AdminRatioResponseFromJSON(json['month12']),
        'all': json['all'] == null ? undefined : AdminRatioResponseFromJSON(json['all']),
        'lastComputation': json['lastComputation'] == null ? undefined : (new Date(json['lastComputation'])),
    };
}

export function AdminConversationRateResponseToJSON(value?: AdminConversationRateResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileId': value['profileId'],
        'month1': AdminRatioResponseToJSON(value['month1']),
        'month3': AdminRatioResponseToJSON(value['month3']),
        'month12': AdminRatioResponseToJSON(value['month12']),
        'all': AdminRatioResponseToJSON(value['all']),
        'lastComputation': value['lastComputation'] == null ? undefined : ((value['lastComputation']).toISOString().substring(0,10)),
    };
}

